import Component from '../abstracts/Component';
import NewsletterLogic from '../logics/NewsletterLogic';

export default class NewsletterFooterComponent extends Component {
  get SELECTORS() {
    return {
      form: '[data-newsletter-form]',
      input: '[data-newsletter-input]',
      submitButton: '[data-newsletter-footer-submit]',
      privacyCheckbox: '[data-newsletter-privacy]',
      // Attributes
      isKorea: 'data-is-korea',
    };
  }

  get CLASSES() {
    return {
      show: 'show',
      success: 'success',
    };
  }

  constructor(htmlEl) {
    super(htmlEl);
    this.isKorea =
      `${this.$component.getAttribute(this.SELECTORS.isKorea)}` === 'true';

    this.form = this.$component.querySelector(this.SELECTORS.form);
    this.input = this.$component.querySelector(this.SELECTORS.input);
    this.submitButton = this.$component.querySelector(
      this.SELECTORS.submitButton
    );

    // Bind privacy DOM element for NO KR country case
    if (!this.isKorea) {
      this.privacyCheckbox = this.$component.querySelector(
        this.SELECTORS.privacyCheckbox
      );
    }

    // loading logics
    this.NewsletterLogic = new NewsletterLogic();
  }

  bindEvents() {
    // Bind events for NO KR country case
    if (!this.isKorea) {
      this.NewsletterLogic.manageNewsletterForm(this);
    } else {
      this.NewsletterLogic.onFormSubmit(this);
    }
  }

  render() {
    super.render();
    this.bindEvents();
  }
}
